import React from 'react'
import { Container } from 'pcln-design-system'
import AdBanner from '@/components/AdBanner'
import { AdBox, AdContent } from '@/components/AdContent'
import AppDownloadWrapper from '@/components/AppDownloadWrapper'
import EmailSignUp from '@/components/EmailSignUp'
import FlyPriceDrop from '@/components/FlyPriceDrop'
import FlightsTripActivity from '@/components/TripActivity/FlightsTripActivity/FlightsTripActivity'
import useGetMostRecentFlightSearch from '@/components/TripActivity/FlightsTripActivity/useGetMostRecentFlightSearch'
import LayoutComponentWrapper from '@/components/LayoutComponentWrapper'
import LinksWidget from '@/components/SkyMondeSeo/LinksWidget'
import useBootstrapData from '@/hooks/useBootstrapData'

function Content() {
  const mostRecentFlightSearchData = useGetMostRecentFlightSearch()
  const { skymondeSEO } = useBootstrapData()

  return (
    <Container size="xl" mb={5}>
      {mostRecentFlightSearchData.length > 0 && (
        <FlightsTripActivity
          mostRecentFlightSearchData={mostRecentFlightSearchData}
        />
      )}
      <FlyPriceDrop />
      <LayoutComponentWrapper topGap>
        <EmailSignUp appCode="DESKTOP" sourceId="LANDING_AIR" />
        <AdContent>
          <AdBox type="primary">
            <div data-testid="flight-ad-1" id="div-gpt-ad-1510165758104-0" />
          </AdBox>
          <AdBox type="secondary">
            <div data-testid="flight-ad-2" id="div-gpt-ad-1510169021467-0" />
          </AdBox>
          <AdBox type="tertiary">
            <div data-testid="flight-ad-3" id="div-gpt-ad-1510169161509-0" />
          </AdBox>
        </AdContent>
        <AppDownloadWrapper />
        <AdBanner>
          <div data-testid="flight-ad-4" id="div-gpt-ad-1510169283152-0" />
        </AdBanner>
        {skymondeSEO && <LinksWidget data={skymondeSEO} />}
      </LayoutComponentWrapper>
    </Container>
  )
}
export default Content
